var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.678879 0.581752C0.169721 1.01817 0 1.92715 0 4.58182V8H6.9999H14V4.61811C14 -0.0364406 14.0423 8.66705e-06 6.87271 8.66705e-06C2.41822 8.66705e-06 1.18785 0.109039 0.678879 0.581752Z",
    fill: "url(#paint0_linear_1008_877)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_877",
    x1: 1.54478,
    y1: 0.103671,
    x2: 7.15347,
    y2: 10.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D6F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiInside);
export default __webpack_public_path__ + "static/media/Ai-inside.34c646ebaff0b6d4f5db943832c8a15b.svg";
export { ForwardRef as ReactComponent };